import { render, staticRenderFns } from "./DetailConfig2.vue?vue&type=template&id=c3d1213c&"
import script from "./DetailConfig2.vue?vue&type=script&lang=js&"
export * from "./DetailConfig2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports